<template>
    <v-content>
        <section>
            <v-parallax :src="require('@/assets/bombe.jpg')" height="600">
                <v-layout
                        column
                        align-center
                        justify-center
                        class="white--text"
                >
                    <img :src="require('@/assets/logo.png')"
                         height="400"
                         class="grey darken-4"
                    />
                    <v-btn
                            class="black white--text lighten-2 mt-5"
                            dark
                            large
                            @click="$vuetify.goTo('#moment', { offset: -0 ,duration:1000 })"
                    >
                        En savoir plus
                    </v-btn>
                </v-layout>
            </v-parallax>
        </section>

        <section>
            <v-layout
                    column
                    wrap
                    class="my-5"
                    align-center
            >
                <v-flex xs12 sm4 class="my-3 px-5">
                    <div class="text-xs-center">
                        <h2 class="headline" id="moment">Un moment inoubliable pour vos collaborateurs, membres de la
                            famille, amis...</h2>
                        <span class="subheading">
                <blockquote class="">
                    &#8220;Attention, ça va péter !&#8221;
                    <footer>
                        <small>
                            <em>&mdash;Les deux grands fous!</em>
                        </small>
                    </footer>
                </blockquote>
              </span>
                    </div>
                </v-flex>
            </v-layout>
        </section>
        <section>
            <v-layout row wrap align-center >
                <v-flex xs12 sm10 class="offset-sm1">
                    <v-card color="light-blue darken-3" class="white--text">
                        <v-card-title primary-title>
                            <div>
                                <div class="headline">Le concept</div>
                                <span>Bomba-Nygma est une animation ludique et interactive qui se rapproche du concept d'escape game, mais avec une approche différente puisqu'elle permet de jouer avec un très grand groupe de joueurs. Alors que les participants pensent qu'ils vont à une conférence sur un sujet fastidieux, un vin d'honneur traditionnel, etc. Ils se retrouvent finalement face à la Bomba-Nygma et auront un temps limité pour réussir à la désamorcer en participant à des épreuves énigmatiques et ludiques.</span>
                            </div>
                        </v-card-title>
                        <v-card-actions>
                            <v-btn flat dark v-on:click="showContact">Réservez maintenant</v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-carousel>
                        <v-carousel-item
                                v-for="(item,i) in items"
                                :key="i"
                                :src="item.src"
                        ></v-carousel-item>
                    </v-carousel>
                </v-flex>

            </v-layout>
        </section>

        <section>
            <v-layout
                    column
                    wrap
                    class="my-5"
                    align-center
            >
                <v-flex xs12>
                    <v-btn to="gallery" dark class="xs12 ma-0" style="width: 100vw;height: 10vh;">Découvrir les photos de nos
                        dernières parties !
                    </v-btn>
                </v-flex>
                <v-flex xs12>
                    <v-container grid-list-xl>
                        <v-layout row wrap align-center>
                            <v-flex xs12 md4>
                                <v-card class="elevation-0 transparent">
                                    <v-card-text class="text-xs-center">
                                        <v-btn fab class="black">
                                            <v-icon x-large class="black white--text text--lighten-2">color_lens
                                            </v-icon>
                                        </v-btn>
                                    </v-card-text>
                                    <v-card-title primary-title class="layout justify-center">
                                        <div class="headline text-xs-center">Thématisable</div>
                                    </v-card-title>
                                    <v-card-text>
                                        Bomba-Nygma possède un scénario par défaut qui ravira vos invités, mais sa
                                        particularité est la possibilité d'en faire une version qui sera complètement
                                        adaptée à votre évènement en créant une thématique rien que pour vous.
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-card class="elevation-0 transparent">
                                    <v-card-text class="text-xs-center">
                                        <v-btn fab class="black">
                                            <v-icon x-large class="black white--text text--lighten-2">flash_on</v-icon>
                                        </v-btn>
                                    </v-card-text>
                                    <v-card-title primary-title class="layout justify-center">
                                        <div class="headline">Durée paramétrable</div>
                                    </v-card-title>
                                    <v-card-text>
                                        D'un groupe d'une dizaine de personne jusqu'à plus d'une centaine, pour une
                                        heure ou deux voir plus, c'est vous qui construisez avec nous de grands moments
                                        !
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-card class="elevation-0 transparent">
                                    <v-card-text class="text-xs-center">
                                        <v-btn fab class="black">
                                            <v-icon x-large class="black white--text text--lighten-2">build</v-icon>
                                        </v-btn>
                                    </v-card-text>
                                    <v-card-title primary-title class="layout justify-center">
                                        <div class="headline text-xs-center">Ludique classique et numérique</div>
                                    </v-card-title>
                                    <v-card-text>
                                        Bomba-Nygma est construit autour des nouvelles technologies du web, mais c'est
                                        aussi une animation de grande cohésion de groupe, avec des énigmes, des
                                        manipulations, etc. L'ensemble restant accessible à tous.
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
        </section>
        <section>
            <v-layout row wrap align-center class="mb-5">
                <v-flex xs12 sm10 class="offset-sm1">
                    <v-card color="light-blue darken-3" class="white--text">
                        <v-card-title primary-title>
                            <div>
                                <div class="headline">Une création unique et française !</div>
                                <span><p class="text-xs-justify">Bomba-Nygma a été créé dans la ville de Besançon à la recherche d'un nouveau format d'escape game disponible pour des sociétés cherchant à faire du team building, des événements accueillants beaucoup de participants.</p>
                                    <p class="text-xs-justify">Le logiciel et la technologie interne sont des développements propriétaires à la société <a href="https://jinic-media.com" target="_blank" class="white--text">Jinic-Média</a>, ils reposent essentiellement sur des composants Open-Source.</p>
                                    <p class="text-xs-justify">La partie ludique et les énigmes sont développées en collaboration avec la société <a href="https://culturejeux.org/" target="_blank" class="white--text">Culture Jeux</a> ainsi que les animations.</p></span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>

            </v-layout>
        </section>

        <section>
            <v-parallax :src="require('@/assets/ensemble.jpg')" height="380">
                <v-layout column align-center justify-center>
                    <div class="headline black--text mb-3 text-xs-center">Le ludique pour créer du lien</div>
                    <em class="black--text">Préparer votre animation dès aujourd'hui</em>
                    <v-btn
                            class="black mt-5"
                            dark
                            large
                            v-on:click="showContact"
                    >
                        Nous contacter
                    </v-btn>
                </v-layout>
            </v-parallax>
        </section>

        <section>
            <v-container grid-list-xl>
                <v-layout row wrap justify-center class="my-5">
                    <v-flex xs12 sm4 offset-sm1>
                        <v-card class="elevation-0 transparent">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline" id="contact">Contactez-nous</div>
                            </v-card-title>
                            <v-card-text>
                                Vous n'êtes qu'à un click d'une formidable aventure.
                            </v-card-text>
                            <v-list class="transparent">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-btn fab small class="black" v-on:click="startCall">
                                            <v-icon class="white--text text--lighten-2">phone</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-on:click="startCall">07 83 31 67 25</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-btn fab small class="black">
                                            <v-icon class="white--text text--lighten-2">place</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Besançon, FR</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-btn fab small class="black" v-on:click="showContact">
                                            <v-icon class="white--text text--lighten-2">email</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-on:click="showContact">Cliquez ici</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card>
                    </v-flex>
                    <v-layout column align-center justify-center>
                        <mentions-legales></mentions-legales>
                    </v-layout>
                </v-layout>
            </v-container>
        </section>
    </v-content>
</template>

<script>
    import {mapMutations} from 'vuex';
    import MentionsLegales from "../components/MentionsLegales";

    export default {
        components: {MentionsLegales},
        data: function () {
            return {
                items: [
                    {
                        src: process.env.BASE_URL + './img/carousel/bomba_pic.webp'
                    },
                    {
                        src: process.env.BASE_URL + './img/carousel/mains.webp'
                    },
                    {
                        src: process.env.BASE_URL + './img/carousel/tablette.webp'
                    }
                ]
            }
        },
        methods: {
            ...
                mapMutations([
                        'showContact',
                        'showMentionLegal'
                    ]
                ),
            startCall() {
                window.location.href = 'tel:+33783316725'
            }
        }
    }
</script>
